import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { InvoiceType } from "@jugl-web/rest-api";
import warningAnimation from "./assets/warningAnimation.json";

type NoSettingsAlertProps = {
  isOpen: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
  type?: InvoiceType;
};

export const NoSettingsAlert = ({
  isOpen,
  onAccept,
  onCancel,
  type = "invoice",
}: NoSettingsAlertProps) => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();

  return (
    <div>
      <Alert
        isOpen={isOpen}
        img={
          <Lottie
            options={{
              animationData: warningAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            width={120}
            height={80}
          />
        }
        title={t({
          id: "invoices.no-settings.title",
          defaultMessage: "Invoice Settings Not Configured",
        })}
        content={t({
          id: "invoices.no-settings.description",
          defaultMessage:
            "You haven’t set up your invoice settings yet. Creating an invoice now will use default values.",
        })}
        buttons={[
          {
            text: t({
              id: "invoices.no-settings.create-anyway",
              defaultMessage: "Create Anyway",
            }),
            role: "close",
            onClick: () => {
              navigateToPage("invoicesItemForm", { type });
              onCancel?.();
            },
          },
          {
            text: t({
              id: "invoices.no-settings.go-to-settings",
              defaultMessage: "Go to Settings",
            }),
            color: "primary",
            onClick: () => {
              navigateToPage("invoicesSettingsBusinessInformation");
              onAccept?.();
            },
          },
        ]}
      />
    </div>
  );
};
